module.exports = __webpack_public_path__ + "img/tutorial-f05-04.8798608d.png";